'use strict';

var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var jsxRuntime = require('react/jsx-runtime');

var i=({navLinks:e,className:a})=>jsxRuntime.jsx("ul",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-top-bar-nav-links ${a||""}`),children:e?.map((l,n)=>jsxRuntime.jsx("li",{className:"item",children:l},n))}),t=i;

exports.a = t;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-WUBA6PV6.js.map